import { takeLatest, put, call } from 'redux-saga/effects';
import { getListCustoMaquinarios } from '../service';
import { formatDateDDMMYYYY } from '@components/common/format';
import {
    CONFIG_SESSION,
    CUSTO_LIST_MAQUINARIOS,
    CUSTO_LIST_MAQUINARIOS_PENDING,
    CUSTO_LIST_MAQUINARIOS_SUCCESS,
    CUSTO_LIST_MAQUINARIOS_FAILURE,
} from '@handler';
import { storage } from '@commons/storage';

function* fetchListCustoMaquinarios(action) {
  yield put({ type: CUSTO_LIST_MAQUINARIOS_PENDING });

  try {
    const session = JSON.parse(storage.get(CONFIG_SESSION));
    const idFazenda = session.fazendaSelecionada?.id ?? -1;
    const idSafra = session.safraAtiva?.id ?? -1;
    const dataInicial = formatDateDDMMYYYY(action.dataInicial);
    const dataFinal = formatDateDDMMYYYY(action.dataFinal);

    const dadosListCustosMaquinarios = yield call(getListCustoMaquinarios, idFazenda, idSafra, dataInicial, dataFinal);
    yield put({ type: CUSTO_LIST_MAQUINARIOS_SUCCESS, dadosListCustosMaquinarios });
  } catch (err) {
    yield put({ type: CUSTO_LIST_MAQUINARIOS_FAILURE });
  }
}

export default function* watchListCustoMaquinarios() {
  yield takeLatest(CUSTO_LIST_MAQUINARIOS, fetchListCustoMaquinarios);
}
